import { boot } from 'quasar/wrappers'
import Parse from 'parse/dist/parse.min.js'
import { EventEmitter } from 'events'

export default boot(({ app }) => {
  // Parse 6.x LiveQuery needs an EventEmitter implementation registered for
  // subscription `.on()` events to fire (used by the support chat).
  // @ts-ignore
  Parse.CoreManager.set('EventEmitter', EventEmitter)
  // @ts-ignore
  Parse.initialize(process.env.Parse.APP_ID)
  // @ts-ignore
  Parse.serverURL = process.env.Parse.PARSE_SERVER_URL
  app.config.globalProperties.$parse = Parse
})

export { Parse }
